import { useState } from 'react';
import { Button, Form, Card, Row, Col } from 'react-bootstrap';
import {
  FaBalanceScale,
  FaUserTie,
} from 'react-icons/fa';
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
interface Props {
  value: {
    service: string;
    location: string;
    advisor: string;
  };
  onNext: (val: { service: string; location: string; advisor: string }) => void;
}

const ServiceSelector = ({ value, onNext }: Props) => {
  const [service, setService] = useState(value.service);
  const [location, setLocation] = useState(value.location);
  const [advisor, setAdvisor] = useState(value.advisor);
  const [mode, setMode] = useState<'inperson' | 'online' | ''>('');

  const handleNext = () => {
    if (service && location && advisor) {
      onNext({ service, location, advisor });
    }
  };

  return (
    <div >
      <Row className="justify-content-center">
        <Col xs={12} lg={8}>
          <Card className="appointment-border rounded-0 shadow-sm">
            <Card.Header className="bg-blue text-light rounded-0 py-3 py-md-4 border-0">
              <p className="mb-0  fw-light letter-spacing-1 fw-semibold text-center ">
                <span className="responsive-text">
                  Legal Consultation Booking
                </span>
              </p>
            </Card.Header>

            <Card.Body className="p-3 p-md-5">
              <Form.Group className="mb-4 mb-md-5">
                <Form.Label className="d-block text-uppercase small fw-bold text-muted mb-2 mb-md-3">
                  Select Service
                </Form.Label>
                <Form.Select
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                  className="py-2 py-md-3 px-3 px-md-4 border-top-0 border-start-0 border-end-0 rounded-0 border-dark border-2 bg-light w-100"
                >
                  <option value="">Select a legal service...</option>
                  <option value="Corporate Legal Solution & Compliance">
                    Corporate Legal Solutions & Compliance
                  </option>
                  <option value="Litigation & Dispute Resolution">
                    Litigation & Dispute Resolution
                  </option>
                  <option value="Land Revenue Litigation & Real Estate Legal Service">
                    Land Revenue & Real Estate Legal Services
                  </option>
                  <option value="High-Volume Legal Drafting & LPO Service">
                    Legal Process Outsourcing (LPO) Services
                  </option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-4 mb-md-5">
                <Form.Label className="d-block text-uppercase small fw-bold text-muted mb-2 mb-md-3">
                  Appointment
                </Form.Label>
                <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">

                  <button
                    type="button"
                    className={`mode-button btn btn-outline-dark rounded-0 py-2 py-md-3 px-3 px-md-4 d-flex align-items-center justify-content-center w-100 w-md-auto ${mode === 'inperson' ? 'active' : ''
                      }`}
                    onClick={() => {
                      setMode('inperson');
                      setLocation('');
                    }}
                  >
                    <FaMapMarkerAlt  className="me-2 fs-5" />
                    In-Person
                  </button>


                  <button
                    type="button"
                    className={`mode-button btn btn-outline-dark rounded-0 py-2 py-md-3 px-3 px-md-4 d-flex align-items-center justify-content-center w-100 w-md-auto ${mode === 'online' ? 'active' : ''
                      }`}
                    onClick={() => {
                      setMode('online');
                      setLocation('');
                    }}
                  >
                    <FaVideo className="me-2 fs-5" />
                    Online
                  </button>

                </div>
              </Form.Group>

              {mode && (
                <Form.Group className="mb-4 mb-md-5">
                  <Form.Label className="d-block text-uppercase small fw-bold text-muted mb-2 mb-md-3">
                    {mode === 'inperson'
                      ? 'Office Location'
                      : 'Meeting Details'}
                  </Form.Label>
                  <Form.Select
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    className="py-2 py-md-3 px-3 px-md-4 border-top-0 border-start-0 border-end-0 rounded-0 border-dark border-2 bg-light w-100"
                  >
                    <option value="">
                      Select{' '}
                      {mode === 'inperson' ? 'location' : 'meeting option'}
                      ...
                    </option>
                    {mode === 'inperson' ? (
                      <option value="Sharjah - United Arab Emirates">
                        Sharjah Office - United Arab Emirates
                      </option>
                    ) : (
                      <option value="https://meet.google.com/cjr-axlf-uxc">
                        Google Meet Session
                      </option>
                    )}
                  </Form.Select>
                </Form.Group>
              )}

              <Form.Group className="mb-4 mb-md-5">
                <Form.Label className="d-block text-uppercase small fw-bold text-muted mb-2 mb-md-3">
                  Advisor
                </Form.Label>
                <Form.Select
                  value={advisor}
                  onChange={(e) => setAdvisor(e.target.value)}
                  className="py-2 py-md-3 px-3 px-md-4 border-top-0 border-start-0 border-end-0 rounded-0 border-dark border-2 bg-light w-100"
                >
                  <option value="">Select your advisor...</option>
                  <option value="pritesh shah">Advocate Pritesh Shah</option>
                </Form.Select>
              </Form.Group>

              <div className="d-flex justify-content-center justify-content-md-end mt-4 mt-md-5 pt-3 border-top border-dark">
                <Button
                  onClick={handleNext}
                  disabled={!service || !mode || !location || !advisor}
                  className="rounded-2 fw-semibold letter-spacing-1  w-md-auto"
                  style={{
                    minWidth: '180px',
                    minHeight: '45px',
                    outline: 'none',
                    boxShadow: 'none',
                    border: 'none',
                    background: '#082341',
                    color: '#ffffff',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#082341';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.outline = 'none';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  Continue to Scheduling
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>


    </div>
  );
};

export default ServiceSelector;
